import { render, staticRenderFns } from "./aruitab.vue?vue&type=template&id=7a788135&scoped=true"
import script from "./aruitab.vue?vue&type=script&lang=js"
export * from "./aruitab.vue?vue&type=script&lang=js"
import style0 from "./aruitab.vue?vue&type=style&index=0&id=7a788135&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a788135",
  null
  
)

export default component.exports